import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetPageByType = (contentTypeUid) => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getMainMenu = async () => {
        const response = await getEntry({
            stack,
            contentTypeUid,
            locale: locale.alias,
        })
        return response && response[0] ? response[0] : null
    }

    const query = useQuery([contentTypeUid], () => getMainMenu())

    return query
}
